import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";
import { CartSummaryMethodsResults } from "@NA/Services/ADICartSummaryService";
import CartSummaryMethodState from "../Data/ADICartSummaryMethodState";

const initialState: CartSummaryMethodState = {
    isLoading: false,
    CartSummaryMethods: undefined,
    deliveryMethodInProgress: false,
};

const reducer = {
    "Custom/loadCartSummary": (draft: Draft<CartSummaryMethodState>, action: { result: CartSummaryMethodsResults }) => {
        draft.isLoading = true;
    },
    "Custom/DispatchCompleteGetCartSummary": (
        draft: Draft<CartSummaryMethodState>,
        action: { cartSummaryMethod: CartSummaryMethodsResults },
    ) => {
        draft.isLoading = false;
        draft.CartSummaryMethods = action.cartSummaryMethod;
    },
    "Custom/DeliveryMethodChanges/BeginLoading": (draft: Draft<CartSummaryMethodState>, action: { result: boolean }) => {
       // draft.deliveryMethodInProgress = action.result;
    },
    "Custom/DeliveryMethodChanges/CompleteLoading": (
        draft: Draft<CartSummaryMethodState>,
        action: { result: boolean },
    ) => {
       // draft.deliveryMethodInProgress = action.result;
    },
   
};

export default createTypedReducerWithImmer(initialState, reducer);
